import React, { useContext, useState } from 'react'

export const AngleNavbarContext = React.createContext(
  {} as { barIsOpen: boolean; toggleBar: Function }
)

export const useAngleNavbar = () => useContext(AngleNavbarContext)
